import React from 'react'
import { array, func, string } from 'prop-types'
import axios from 'axios'

import DirectUploadFiles from 'Utils/DirectUploadFiles'

function DirectUploadImages({
  modelId,
  files,
  onFileUploadFinish,
  onUploadFailure,
  onUploadProgress,
  clearFiles,
}) {
  function finalizeUpload(blobId) {
    axios.put(`/api/internal/direct-uploads/item-images/${blobId}`, { item_id: modelId })
      .then((response) => {
        onFileUploadFinish(blobId, response.data.data.attributes)
      })
      .catch(onUploadFailure)
  }

  return (
    <DirectUploadFiles
      files={files}
      onUploadStart={clearFiles}
      finalizeUpload={finalizeUpload}
      onUploadProgress={(fileName, progress) => onUploadProgress(fileName, null, progress)}
    />
  )
}

DirectUploadImages.propTypes = {
  modelId: string.isRequired,
  files: array.isRequired,
  onFileUploadFinish: func.isRequired,
  onUploadFailure: func.isRequired,
  onUploadProgress: func.isRequired,
  clearFiles: func.isRequired,
}

export default DirectUploadImages
